
import { defineComponent } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';

export default defineComponent({
  name: 'BaseDialog',
  setup() {
    const { purchaseCount } = useInsertDataStore();
    return {
      purchaseCount,
    };
  },
});
